<cc-container>
  <cc-white-block>
    <cc-header-block>
      <div>
        <img
          src="../../../assets/img/import.png"
          height="40"
          alt="import">
        <label for="file" class="classic-link" translate>IMPORTS.DESCRIPTION.CHOOSE_FILE</label>
        <input type="file"
               accept=".csv,.xlsx"
               id="file"
               (change)="handleFileInput($event.target.files)">
      </div>

      <div translate>BLACKLIST.CHOOSE.{{this.action}}.INFO</div>
      <div translate>IMPORTS.DESCRIPTION.INFO_PART_1</div>
      <div translate>BLACKLIST.IMPORT.DESCRIPTION.INFO_PART_2</div>
      <div translate>IMPORTS.DESCRIPTION.INFO_PART_3</div>
    </cc-header-block>
  </cc-white-block>
  <div class="line-through light-grey-text"><span class="m-x-xs" translate="IMPORTS.OR"></span></div>
  <cc-white-block>
    <cc-header-block>
      <div>
        <img
          src="../../../assets/img/add_individual_contacts.png"
          alt="add_individual_contacts">
        <span translate>BLACKLIST.{{this.action}}_CONTACTS.HEADER</span>
      </div>
      <div translate>BLACKLIST.CHOOSE.{{this.action}}.DESCRIPTION</div>
      <div translate>BLACKLIST.CHOOSE.{{this.action}}.ROW</div>
    </cc-header-block>

    <button
      mat-raised-button
      type="button"
      [routerLink]="['/blacklist/manual-import', this.action.toLowerCase()]"
      color="primary">
      <span translate>BLACKLIST.{{this.action}}</span>
    </button>
  </cc-white-block>
</cc-container>
